import React from 'react';
import './SfasTransactionFeeTerms.scss';
import Helpers from '../../utils/helper';

export interface SfasTransactionFeeTermsProps {
    startLtmRevenue: number;
    ltmRevenueThresholdPercent: number | null | undefined;
    feePercentOnTotalFairValue: number | null | undefined;
    feePercentOnExcessFairValue: number | null | undefined;
}

export const hasCompleteSfasFeeTerms = (
    sfasParams:
        | {
              startLtmRevenue?: number | null;
              ltmRevenueThresholdPercent?: number | null;
              feePercentOnTotalFairValue?: number | null;
              feePercentOnExcessFairValue?: number | null;
          }
        | null
        | undefined
): boolean =>
    !!sfasParams &&
    sfasParams.startLtmRevenue != null &&
    sfasParams.startLtmRevenue > 0 &&
    sfasParams.ltmRevenueThresholdPercent != null &&
    sfasParams.feePercentOnTotalFairValue != null &&
    sfasParams.feePercentOnExcessFairValue != null;

export const SfasTransactionFeeTerms = (
    props: SfasTransactionFeeTermsProps
) => {
    const thresholdDollars =
        props.startLtmRevenue > 0 && props.ltmRevenueThresholdPercent != null
            ? (props.startLtmRevenue * props.ltmRevenueThresholdPercent) / 100
            : 0;

    return (
        <div className="transaction-fee-sentence">
            <p>The greater of:</p>
            <p>
                {props.feePercentOnTotalFairValue?.toFixed(1)}% of Total Deal
                Value if Value is less than{' '}
                {Helpers.GetCurrencyFormat(thresholdDollars, 0)}
            </p>
            <p>
                {props.feePercentOnExcessFairValue?.toFixed(1)}% of the excess
                of Total Deal Value above{' '}
                {Helpers.GetCurrencyFormat(thresholdDollars, 0)}
            </p>
        </div>
    );
};
